"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipLink = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _BrowserDefaultFocusStyleContext = require("../../contexts/BrowserDefaultFocusStyleContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _Link = require("./Link.js");
var _LinkText = require("./LinkText.js");
var _excluded = ["className", "colorSet", "children", "isFocus"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * SkipLink is a way to make a UI more accessible. It allows assistive technology users to bypass navigation and get to main content faster.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-skiplink--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/SkipLink)
 */
var SkipLink = exports.SkipLink = function SkipLink(_ref) {
  var className = _ref.className,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'invertedDark' : _ref$colorSet,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? 'Skip to content' : _ref$children,
    isFocus = _ref.isFocus,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_BrowserDefaultFocusStyleContext.BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;
  return /*#__PURE__*/_react["default"].createElement(_Link.Link, Object.assign({
    $useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    $isFocus: isFocus,
    className: (0, _index.addColorSet)(colorSet, className)
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.SkipLink
  }), /*#__PURE__*/_react["default"].createElement(_LinkText.LinkText, null, children));
};